import { render, staticRenderFns } from "./MoreActionsDropdown.vue?vue&type=template&id=2ac7ffcf&scoped=true"
import script from "./MoreActionsDropdown.vue?vue&type=script&lang=js"
export * from "./MoreActionsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac7ffcf",
  null
  
)

export default component.exports